import styled from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
export const ButtonCol = styled(Col) `
  flex: inherit;
`;
